export default __webpack_public_path__ + "static/media/contact-us-top-shape.274372b4.svg";